import Entity from '../entity';
import FlightItem from './flightItem';

export default class FlightPayment extends Entity<string> {
  total: number;
  currencyId: string;
  flightItems: FlightItem[];
  tourItems: any[];
  ticketItems: any[];
  insurerItems: any;
}
